import { IndexedPublicationsSection } from 'about/ui/indexedPublications/IndexedPublicationsSection'

export const indexedPublicationsDToF: readonly IndexedPublicationsSection[] = [
  {
    letter: 'D',
    references: [
      '@bib{riva2018two};',
      '@bib{Nisaba_5};',
      '@bib{dagostino2003silverrings};',
      '@bib{OECT_15};',
      '@bib{OECT_13};',
      '@bib{danmanville1960deux};',
      '@bib{vondassow2000neobabylonian};',
      '@bib{vondassow2000neobabylonianprivate}; ',
      '@bib{RN2265};',
      '@bib{debourse2022priests};',
      '@bib{Deimel1920Eine};',
      '@bib{Deimel1920Ninurra};',
      '@bib{delaunay1977moldenke};',
      '@bib{LS151};',
      '@bib{deller1995saab9}; ',
      '@bib{Devecchi2017Kings};',
      '@bib{devecchi2025gula};',
      '@bib{CT0054};',
      '@bib{RN2769};',
      '@bib{dietrich1969soziale};',
      '@bib{dietrich1969sozialeb};',
      '@bib{dietrich1970soziale};',
      '@bib{dietrich1997vertrag};',
      '@bib{TLB_2};',
      '@bib{LS82};',
      '@bib{VS_17};',
      '@bib{RN570};',
      '@bib{RN569};',
      '@bib{dijk2003ur};',
      '@bib{YOS_11};',
      '@bib{Donbaz1979Another};',
      '@bib{Donbaz1983Building};',
      '@bib{Donbaz1985Zwei};',
      '@bib{Donbaz1990Fragments};',
      '@bib{Donbaz1990Two};',
      '@bib{Donbaz1991Brick};',
      '@bib{NABU1998-9};',
      '@bib{donbaz2001ninive};',
      '@bib{Donbaz2001Some};',
      '@bib{NABU2002-90};',
      '@bib{Donbaz2009Middle};',
      '@bib{KAM11};',
      '@bib{donbaz1995astrolab};',
      '@bib{RN2110};',
      '@bib{RN932};',
      '@bib{YOS_20};',
      '@bib{YOS_6};',
      '@bib{OECT_3};',
      '@bib{driver1933cappadocian};',
      '@bib{Durand2023FSMaul}',
    ],
  },
  {
    letter: 'E',
    references: [
      '@bib{RN2605};',
      '@bib{RN2742};',
      '@bib{RN1271vv};',
      '@bib{Edzard2000U7804};',
      '@bib{LS184};',
      '@bib{eilers1935eine};',
      '@bib{ellis1984neobabylonian};',
      '@bib{ellis1997notes};',
      '@bib{englund2014late};',
      '@bib{MSVO_1};',
      '@bib{epping1891neue};',
      '@bib{epping1891neue2};',
      '@bib{epping1891neue3};',
      '@bib{evetts1892inscriptions}',
    ],
  },
  {
    letter: 'F',
    references: [
      '@bib{BB03};',
      '@bib{RN2732};',
      '@bib{Fadhil2023FSMaul};',
      '@bib{BB07kk};',
      '@bib{SipLib2};',
      '@bib{SipLib3};',
      '@bib{fadhil2023literary};',
      '@bib{fahd1996نصوص};',
      '@bib{NAR3};',
      '@bib{RN2304};',
      '@bib{fales1991saab5};',
      '@bib{RN311h};',
      '@bib{RN311i}; ',
      '@bib{falkenstein_literarische_1931};',
      '@bib{RN1355};',
      '@bib{Farber1991Shalim-ahum};',
      '@bib{RN1824};',
      '@bib{YOS_8}; ',
      '@bib{YOS_12};',
      '@bib{TLB_5};',
      '@bib{Fiette2020archives};',
      '@bib{Fiette2020echanges};',
      '@bib{Fiette2020habitants};',
      '@bib{Fiette2020reprNABU2017-70};',
      '@bib{VS_13};',
      '@bib{UET_4};',
      '@bib{Figulla1953Accounts};',
      '@bib{CT0042};',
      '@bib{CT0043};',
      '@bib{CT0047};',
      '@bib{UET_5};',
      '@bib{RN2766};',
      '@bib{Fincke2009CM37};',
      '@bib{UBHD-67658607};',
      '@bib{fincke_additions_2014};',
      '@bib{RN7388};',
      '@bib{UBHD-67658607aa};',
      '@bib{temp_id_28837618947954713};',
      '@bib{Fincke2017Additions}; ',
      '@bib{temp_id_9814145298557961};',
      '@bib{RN172xa};',
      '@bib{Fincke2021InSearch};',
      '@bib{RN2672};',
      '@bib{RN1609}; ',
      '@bib{Finkel1988Fragment};',
      '@bib{RN168};',
      '@bib{finkel2005documents};',
      '@bib{RN1804};',
      '@bib{finkelstein1957assyrian}; ',
      '@bib{CT0048};',
      '@bib{YOS_13};',
      '@bib{NABU2012-64};',
      '@bib{fromebllab0004};',
      '@bib{fromebllab0006};',
      '@bib{fromebllab0012}; ',
      '@bib{fromebllab0020};',
      '@bib{fromebllab0030};',
      '@bib{fromebllab0031};',
      '@bib{foeldi2022inannas};',
      '@bib{fromebllab0043};',
      '@bib{fromebllab0045};',
      '@bib{VS_14}; ',
      '@bib{Foster1990Naram-Sin};',
      '@bib{Foster2020};',
      '@bib{RN812};',
      '@bib{Frahm2023FSMaul};',
      '@bib{YOS_21};',
      '@bib{RN15210aa};',
      '@bib{Frame1987Three};',
      '@bib{Frame1991Mace};',
      '@bib{frame2014nassyrian};',
      '@bib{frame2014nbinscriptions};',
      '@bib{frame2014neoassyrian}; ',
      '@bib{frame2014neoassyrianroyal};',
      '@bib{frame2014neobabylonian}; ',
      '@bib{frame2014neobabylonianinscriptions};',
      '@bib{frame2014neobabylonianroyal}; ',
      '@bib{frame2014royal};',
      '@bib{frame1989cuneiform};',
      '@bib{SAA_22};',
      '@bib{TLB_4};',
      '@bib{AbB_2};',
      '@bib{AbB_3};',
      '@bib{RN1991};',
      '@bib{RN2246};',
      '@bib{Frayne1983New};',
      '@bib{Frayne1984Hammurapi};',
      '@bib{Frayne1984Notes};',
      '@bib{Frazer2020Neo};',
      '@bib{RN148}; ',
      '@bib{freedman2005documents};',
      '@bib{RN1173};',
      '@bib{RN3178}; ',
      '@bib{freydank1971spaetbabylonische};',
      '@bib{VS_19};',
      '@bib{Freydank1985MBLETU};',
      '@bib{MARV_3}; ',
      '@bib{frydank1997noch};',
      '@bib{MARV_4};',
      '@bib{MARV_7}; ',
      '@bib{MARV_5};',
      '@bib{MARV_6};',
      '@bib{RN1278};',
      '@bib{RN1279};',
      '@bib{friberg2005mathematical};',
      '@bib{RN3094xf}; ',
      '@bib{Fuchs2017Kassiten};',
      '@bib{RN311f}',
    ],
  },
]
